import axios from 'axios'

export default axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || 'https://www.ihss.pedaids.org/programs-webmap-back',
    headers:{'Content-Type':'application/json'}
})